import { SubmissionError } from 'redux-form';
import { DOCUMENTS_REQUIRED_FIELDS, REQUIRED_FIELDS } from './constants';
import { goToElement } from '../../utils/goToElement';

const validateDocuments = fields => {
	const documentErrors = { documents: [] };

	fields?.forEach((item, idx) => {
		DOCUMENTS_REQUIRED_FIELDS.forEach(key => {
			if (!item?.[key]) {
				if (!documentErrors?.documents?.[idx]) {
					documentErrors.documents[idx] = {};
				}
				documentErrors.documents[idx][key] = 'Заполните это поле';

				if (!documentErrors.documents[idx].hasScrolled) {
					goToElement(`documents[${idx}].${key}`);
					documentErrors.documents[idx].hasScrolled = true;
				}
			}
		});
	});

	return documentErrors;
};

export const validate = values => {
	const errors = {};

	if (!values.name) {
		errors.name = 'Название обязательно';
		goToElement('name');
	}

	REQUIRED_FIELDS.forEach(key => {
		if (key !== 'documents' && !values?.[key]) {
			errors[key] = 'Заполните это поле';
			goToElement(key);
		}
	});

	if (!errors.name && Object.keys(errors).length === 0) {
		const documentErrors = validateDocuments(values?.documents);

		if (Object.keys(documentErrors.documents).length > 0) {
			Object.assign(errors, documentErrors);
		}
	}

	if (Object.keys(errors).length > 0) {
		throw new SubmissionError(errors);
	}

	return errors;
};

export const transformToValidationErrors = (
	errors,
	{ normalizeDotToBrackets = false, replaceDocumentsNameToCustom = false } = {},
) => {
	if (!errors || typeof errors !== 'object') return {};

	const result = {};
	let hasScrolled = false;

	Object.entries(errors).forEach(([key, value]) => {
		let fieldKey = key;

		if (normalizeDotToBrackets) {
			fieldKey = fieldKey.replace(/\.(\d+)\./g, '[$1].');
		}

		if (!hasScrolled) {
			goToElement(fieldKey);
			hasScrolled = true;
		}

		const match = fieldKey.match(/^documents(?:\.|\[)(\d+)(?:\]?)\.(\w+)$/);
		if (match) {
			const [, indexStr, fieldRaw] = match;

			const index = parseInt(indexStr, 10);

			const field = replaceDocumentsNameToCustom && fieldRaw === 'name' ? 'name' : fieldRaw;

			if (!result.documents) result.documents = [];
			if (!result.documents[index]) result.documents[index] = {};

			result.documents[index][field] = Array.isArray(value) ? value[0] : value;
		} else {
			result[fieldKey] = Array.isArray(value) ? value[0] : value;
		}
	});

	return result;
};
